<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header  border-0">
        <h5 class="card-title font-bold py-3">گزارش سفارشات</h5>
      </div>
      <div class="card-body">
        <form @submit.prevent="submitHandler" class="row">
          <div class="col-5">
            <label>فیلتر تاریخ</label>
            <div class="row">
              <div class="col-6 d-flex">
                <span class="ml-2">از</span>
                <date-picker
                  type="date"
                  v-model="filter.date.startDate"
                  format="YYYY-MM-DD"
                  display-format="jYYYY-jMM-jDD"
                />
              </div>
              <div class="col-6 d-flex">
                <span class="ml-2">تا</span>
                <date-picker
                  name="noname"
                  type="date"
                  v-model="filter.date.endDate"
                  format="YYYY-MM-DD"
                  display-format="jYYYY-jMM-jDD"
                />
              </div>
            </div>
          </div>

          <div class="col-6 mt-5">
            <button :disabled="disabled" type="submit" class="btn btn-primary">
              فیلتر
            </button>
            <button
              @click="removeFilter"
              :disabled="disabled"
              type="button"
              class="btn btn-warning mr-2"
            >
              برداشتن فیلتر
            </button>
          </div>
        </form>
        <table
          id="orderSellTable"
          class="table table-striped table-bordered table-sm mt-5"
          :style="{ opacity: disabled ? '0.6' : 1 }"
        >
          <thead class="thead-light">
            <th>عنوان</th>
            <th>سفارشات آنلاین</th>
            <th>سفارشات حضوری</th>
            <th>جمع کل</th>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in fields"
              :key="index"
              :class="item.statusColor"
            >
              <td>{{ item.label }}</td>
              <td v-if="orderReports">{{ orderReports[item.key] | price }}</td>
              <td v-if="miniOrderReports">
                {{ miniOrderReports[item.key] | price }}
              </td>
              <td v-if="mergedOrderReports">
                {{ mergedOrderReports[item.key] | price }}
              </td>
            </tr>
          </tbody>
        </table>
        <!-- <div v-else-if="mergedOrderReports == ''" class="alert alert-danger">
          موردی یافت تشد
        </div>
        <div v-else class="alert alert-primary">در حال بارگزاری</div> -->
      </div>
    </div>
  </main>
</template>

<script>
import { BTable } from "bootstrap-vue";
class Filter {
  constructor() {
    this.date = {
      startDate: new Date().toISOString().split("T")[0],
      endDate: new Date().toISOString().split("T")[0],
    };
  }
  set(filters) {
    Object.entries(filters).forEach(([index, value]) => {
      this[index] = value;
    });
  }
}
export default {
  name: "OrdersSell",
  components: {
    BTable,
  },
  data() {
    return {
      disabled: true,
      mergedOrderReports: null,
      miniOrderReports: null,
      orderReports: null,
      filter: new Filter(),
      appliedFilter: new Filter(),

      fields: [
        {
          key: "total_amount",
          label: "جمع خالص فروش",
          statusColor: "success",
        },
        {
          key: "total_shipping_amount",
          label: "هزینه ارسال",
          statusColor: "success",
        },
        {
          key: "total_wallet_deposit",
          label: "شارژ کیف پول",
          statusColor: "success",
        },
        {
          key: "total_paid_from_wallet",
          label: "پرداخت از کیف پول",
          statusColor: "warning",
        },
        {
          key: "total_discount_amount",
          label: "جمع کل تخفیفات",
          statusColor: "warning",
        },
        {
          key: "total_paid_by_gateway",
          label: "پرداخت از طریق درگاه",
          statusColor: "info",
        },
        {
          key: "total_orders",
          label: "تعداد سفارشات",
        },
        {
          key: "total_order_items",
          label: "آیتم های سفارش",
        },
        {
          key: "total_refund_items",
          label: "تعداد اقلام مرجوعی",
        },
        {
          key: "total_refund_amount",
          label: "مجموع مبلغ مرجوعی",
        },
        {
          key: "total_cashier_discount_amount",
          label: "تخفیف پای صندوق",
        },
        {
          key: "total_discount_with_coupon",
          label: "تخفیفات دارای کوپن",
        },
        {
          key: "total_discount_without_coupon",
          label: "تخفیفات بدون کوپن",
        },
        {
          key: "total_paid_by_cash",
          label: "پرداخت نقدی",
        },
        {
          key: "total_paid_by_cart_to_card",
          label: "پرداخت کارت به کار ت",
        },
        {
          key: "total_paid_by_pos",
          label: "پرداخت با دستگاه pos",
        },
      ],
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    removeFilter() {
      this.filter = new Filter();
      this.loadData();
    },
    submitHandler() {
      this.loadData();
    },
    async loadData() {
      try {
        this.appliedFilter.set(this.filter);
        this.disabled = true;
        const response = await this.$axios.get(
          "admin/accounting-report/order-sell",
          {
            params: {
              start_date: this.appliedFilter.date.startDate,
              end_date: this.appliedFilter.date.endDate,
            },
          }
        );
        this.mergedOrderReports = response.data.data.merged_array;
        this.miniOrderReports = response.data.data.mini_order_totals;
        this.orderReports = response.data.data.order_totals;
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
  },
};
</script>
<style scoped>
#orderSellTable .success {
  background-color: #cbff7e;
  color: #000000;
}
#orderSellTable .warning {
  background-color: #ffb2b2;
  color: #000000;
}
#orderSellTable .info {
  background-color: #648bff;
  color: #ffffff;
}
</style>
